import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { deleteOrg as deleteOrgAPI } from 'services/apiOrg';

const useDeleteOrg = () => {
  const queryClient = useQueryClient();
  const{isPending: isDeleting, isSuccess: isDeleted, mutate: deleteOrg} = useMutation({
    mutationFn: deleteOrgAPI,
    onSuccess:()=>{
        queryClient.invalidateQueries({queryKey:['orgList']})
        toast.success("Deleted sucessfully")  
    },
    onError:()=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{ isDeleting, isDeleted, deleteOrg}
}

export default useDeleteOrg